import { GalleryGridBlock } from "@ad3d/ui";

// Dummy data for the portfolio
const items = [
  { 
    id: 1, 
    category: "Art & Design", 
    title: "Abstract Harmony", 
    url: "https://picsum.photos/seed/art1/800/600" 
  },
  { 
    id: 2, 
    category: "Apparel", 
    title: "Urban Fashion", 
    url: "https://picsum.photos/seed/fashion1/800/1000" 
  },
  { 
    id: 3, 
    category: "Food", 
    title: "Culinary Delight", 
    url: "https://picsum.photos/seed/food1/800/800" 
  },
  { 
    id: 4, 
    category: "Art & Design", 
    title: "Modern Sculpture", 
    url: "https://picsum.photos/seed/art2/800/1200" 
  },
  { 
    id: 5, 
    category: "Apparel", 
    title: "Street Style", 
    url: "https://picsum.photos/seed/fashion2/800/700" 
  },
  { 
    id: 6, 
    category: "Food", 
    title: "Healthy Living", 
    url: "https://picsum.photos/seed/food2/800/900" 
  },
  { 
    id: 7, 
    category: "Art & Design", 
    title: "Geometric Patterns", 
    url: "https://picsum.photos/seed/art3/800/800" 
  },
  { 
    id: 8, 
    category: "Apparel", 
    title: "Vintage Collection", 
    url: "https://picsum.photos/seed/fashion3/800/1100" 
  },
  { 
    id: 9, 
    category: "Food", 
    title: "Sweet Treats", 
    url: "https://picsum.photos/seed/food3/800/600" 
  },
  {
    id: 10,
    category: "Art & Design",
    title: "Color Splash",
    url: "https://picsum.photos/seed/art4/800/1000"
  },
  {
    id: 11,
    category: "Apparel",
    title: "Summer Vibes",
    url: "https://picsum.photos/seed/fashion4/800/800"
  },
  {
    id: 12,
    category: "Food",
    title: "Fresh Ingredients",
    url: "https://picsum.photos/seed/food4/800/700"
  }
];

export default function Explore() {
  return (
    <div className="flex flex-col h-full w-full overflow-y-auto">
      <GalleryGridBlock 
        items={items} 
        title="Explore Scenes" 
        description="Discover amazing 3D scenes created by our community"
      />
    </div>
  );
}
